<template>
  <div id="SearchKeywordMgmt" style="width: 100%; margin: 0 auto; background: white">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.productType" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productColor">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">机型</span>
        <el-select placeholder="产品机型" size="small" v-model="model">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
        <span class="header-label">投放词</span>
        <el-input placeholder="请输入投放词" size="small" clearable v-model="params.delivery"> </el-input>
        <span class="header-label">关键词</span>
        <el-input placeholder="请输入关键词" size="small" clearable v-model="params.keyword"> </el-input>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku"> </el-input>
        <span class="header-label">Asin</span>
        <el-input placeholder="请输入Asin" size="small" clearable v-model="params.asin"> </el-input>
        <span class="header-label">日期</span>
        <el-date-picker v-model="params.date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 150px"> </el-date-picker>
      </div>
      <div class="header-line">
        <span class="header-label">投放状态</span>
        <el-select placeholder="全部" size="small" v-model="params.isDelivery">
          <el-option label="全部" value=""></el-option>
          <el-option label="已投放" value="1"></el-option>
          <el-option label="未投放" value="0"></el-option>
        </el-select>
        <span class="header-label">推荐状态</span>
        <el-select placeholder="全部" size="small" v-model="params.recommandState">
          <el-option label="全部" value=""></el-option>
          <el-option label="启用投放" value="1"></el-option>
          <el-option label="暂停投放" value="0"></el-option>
        </el-select>
        <span class="header-label">排序类型</span>
        <el-select placeholder="排序类型" size="small" v-model="params.sortType">
          <el-option label="权重" value="weight"></el-option>
          <el-option label="ROAS" value="roas"></el-option>
          <el-option label="展现" value="impressions"></el-option>
          <el-option label="点击" value="clicks"></el-option>
          <el-option label="订单" value="order"></el-option>
          <el-option label="销售" value="sales"></el-option>
        </el-select>
        <span class="header-label">90日展现量</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginImpressions90Day" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endImpressions90Day" style="width: 100px"> </el-input>
        <span class="header-label">90日点击次数</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginClicks90Day" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endClicks90Day" style="width: 100px"> </el-input>
      </div>
      <div class="header-line">
        <span class="header-label">90日订单数</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginOrders90Day" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endOrders90Day" style="width: 100px"> </el-input>
        <span class="header-label">90日点击率</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginClickRate90Day" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endClickRate90Day" style="width: 100px"> </el-input>
        <span class="header-label">90日转化率</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginOrderRate90Day" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endOrderRate90Day" style="width: 100px"> </el-input>
        <span class="header-label">90日ROIM</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginRoim90Day" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endRoim90Day" style="width: 100px"> </el-input>
      </div>
      <div class="header-line">
        <span class="header-label">90日ROAS</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginRoas90Day" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endRoas90Day" style="width: 100px"> </el-input>
        <span class="header-label">关键词权重</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.beginTopTenWeight" style="width: 100px"> </el-input>
        <span>-</span>
        <el-input placeholder="请输入" size="small" clearable v-model="params.endTopTenWeight" style="width: 100px"> </el-input>
        <span class="header-label">搜索词类型</span>
        <el-select placeholder="全部" size="small" v-model="params.type">
          <el-option label="全部" value=""></el-option>
          <el-option label="搜索词" value="keyword"></el-option>
          <el-option label="关联商品" value="product"></el-option>
        </el-select>
        <span class="header-label">匹配类型</span>
        <el-select placeholder="全部" size="small" v-model="params.matchType">
          <el-option label="全部" value=""></el-option>
          <el-option label="精准匹配" value="EXACT"></el-option>
          <el-option label="词组匹配" value="PHRASE"></el-option>
          <el-option label="广泛匹配" value="BROAD"></el-option>
          <el-option label="自动关键词" value="-"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="getAdvertData">查询</el-button>
        <el-button type="primary" size="small" @click="runKeywordStatistics" style="width: 100px">生成统计数据</el-button>
        <el-button type="primary" size="small" @click="createData" style="width: 100px">生成分析数据</el-button>
        <el-button type="primary" size="small" @click="copyKeyword">复制关键词</el-button>
        <el-button v-if="multipleSelection.length > 0" type="primary" size="small" @click="batchAddKeyword">批量新增</el-button>
        <!-- <el-button type="primary" size="small" @click="autoAdjustAd">广告自调整</el-button> -->
      </div>
    </div>
    <el-table ref="table" :data="dataList" stripe size="mini" :height="screenHeight" row-key="_id" :highlight-current-row="true" border @selection-change="handleSelectionChange" show-summary>
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column label="操作" width="50px" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="keywordAnalysis(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="productColorName" label="状态" width="60px" align="center" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.deliveryState" v-if="scope.row.isDelivery == 1" disabled size="mini" active-value="已启用" inactive-value="" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
          <div v-else>
            <el-button type="text" v-if="scope.row.keyword.toLowerCase().startsWith('b0')" size="small" @click="addDeliveryProduct(scope.row)">新增</el-button>

            <el-button type="text" v-else size="small" @click="addDeliveryKeyword(scope.row)">新增</el-button>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="recommandState" label="推荐状态" width="60px" align="center">
        <template v-slot="scope">
          <div>{{ scope.row.recommandState == 1 ? "开启" : "" }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="recommandCpc" label="推荐CPC" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div>{{ getFixed2Value(scope.row.recommandCpc) }}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="shopName" label="店铺" width="60px"> </el-table-column>
      <el-table-column prop="productName" label="产品名称" width="100px">
        <template v-slot="scope">
          <div>{{ scope.row.productName }}</div>
          <div>{{ scope.row.productColorName }}</div>
          <div>{{ scope.row.model }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="campaignName" label="广告活动" width="150px"> </el-table-column>
      <el-table-column prop="sku" label="SKU" width="200px"> </el-table-column>
      <el-table-column prop="delivery" label="投放词" width="200px">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="deliveryKeywordClick(scope.row.delivery)">{{ scope.row.delivery }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="keyword" label="搜索词" width="200px">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="searchKeywordClick(scope.row.keyword)">{{ scope.row.keyword }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="matchType" label="匹配类型" width="80px"> </el-table-column>
      <!-- <el-table-column prop="weight" label="权重" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div :class="{redText : scope.row.weightTopTenState}">{{ scope.row.weight }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="topTenWeight" label="前10权重" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.topTenWeight }}</div>
        </template>
      </el-table-column> -->

      <el-table-column label="统计周期" width="70px" align="right">
        <template>
          <div>90日</div>
          <div class="middleText">30日</div>
          <div>7日</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayImpressions" label="展现" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last90DayImpressions }}</div>
          <div class="middleText inlineRow">{{ scope.row.keywordAllPerformance.last30DayImpressions }}</div>
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last7DayImpressions }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayClicks" label="点击" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last90DayClicks }}</div>
          <div class="middleText inlineRow">{{ scope.row.keywordAllPerformance.last30DayClicks }}</div>
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last7DayClicks }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayOrders" label="订单" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow" :class="getOrderStyleClass(scope.row, 'last90DayOrders')">{{ scope.row.keywordAllPerformance.last90DayOrders }}</div>
          <div class="middleText inlineRow" :class="getOrderStyleClass(scope.row, 'last30DayOrders')">{{ scope.row.keywordAllPerformance.last30DayOrders }}</div>
          <div class="inlineRow" :class="getOrderStyleClass(scope.row, 'last7DayOrders')">{{ scope.row.keywordAllPerformance.last7DayOrders }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayTotal7DayAdSkuCount" label="SKU订单" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last90DayTotal7DayAdSkuCount }}</div>
          <div class="middleText inlineRow">{{ scope.row.keywordAllPerformance.last30DayTotal7DayAdSkuCount }}</div>
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last7DayTotal7DayAdSkuCount }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayTotal7DayOtherSkuCount" label="其他订单" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last90DayTotal7DayOtherSkuCount }}</div>
          <div class="middleText inlineRow">{{ scope.row.keywordAllPerformance.last30DayTotal7DayOtherSkuCount }}</div>
          <div class="inlineRow">{{ scope.row.keywordAllPerformance.last7DayTotal7DayOtherSkuCount }}</div>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="roim90Day" label="ROIM" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div :class="{ redText: scope.row.roim90DayTopTenState }" class="inlineRow">{{ getFixed2Value(scope.row.roim90Day) }}</div>
          <div :class="{ redText: scope.row.roim30DayTopTenState }" class="middleText inlineRow">{{ getFixed2Value(scope.row.roim30Day) }}</div>
          <div :class="{ redText: scope.row.roim7DayTopTenState }" class="inlineRow">{{ getFixed2Value(scope.row.roim7Day) }}</div>
        </template>
      </el-table-column> -->

      <el-table-column prop="keywordAllPerformance.last90DayClickRate" label="点击率" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ getPercentageValue(scope.row.keywordAllPerformance.last90DayClickRate) }}</div>
          <div class="middleText inlineRow">{{ getPercentageValue(scope.row.keywordAllPerformance.last30DayClickRate) }}</div>
          <div class="inlineRow">{{ getPercentageValue(scope.row.keywordAllPerformance.last7DayClickRate) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayConversionRate" label="转化率" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow" :class="getConversionRateStyleClass(scope.row, 'last90DayConversionRate')">{{ getPercentageValue(scope.row.keywordAllPerformance.last90DayConversionRate) }}</div>
          <div class="middleText inlineRow" :class="getConversionRateStyleClass(scope.row, 'last30DayConversionRate')">{{ getPercentageValue(scope.row.keywordAllPerformance.last30DayConversionRate) }}</div>
          <div class="inlineRow" :class="getConversionRateStyleClass(scope.row, 'last7DayConversionRate')">{{ getPercentageValue(scope.row.keywordAllPerformance.last7DayConversionRate) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayROAS" label="ROAS" width="70px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow" :class="getROASStyleClass(scope.row, 'last90DayROAS')">{{ getFixed2Value(scope.row.keywordAllPerformance.last90DayROAS) }}</div>
          <div class="middleText inlineRow" :class="getROASStyleClass(scope.row, 'last30DayROAS')">{{ getFixed2Value(scope.row.keywordAllPerformance.last30DayROAS) }}</div>
          <div class="inlineRow" :class="getROASStyleClass(scope.row, 'last7DayROAS')">{{ getFixed2Value(scope.row.keywordAllPerformance.last7DayROAS) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DayCPC" label="CPC" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last90DayCPC) }}</div>
          <div class="middleText inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last30DayCPC) }}</div>
          <div class="inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last7DayCPC) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DaySpend" label="花费" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last90DaySpend) }}</div>
          <div class="middleText inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last30DaySpend) }}</div>
          <div class="inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last7DaySpend) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keywordAllPerformance.last90DaySales" label="销售" width="60px" align="right" sortable>
        <template v-slot="scope">
          <div class="inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last90DaySales) }}</div>
          <div class="middleText inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last30DaySales) }}</div>
          <div class="inlineRow">{{ getFixed2Value(scope.row.keywordAllPerformance.last7DaySales) }}</div>
        </template>
      </el-table-column>
    </el-table>

    <div class="sum-box">
      <div class="sum-item" style="width: 65px">
        <div>90日</div>
        <div class="middleText">30日</div>
        <div>7日</div>
      </div>
      <div class="sum-item">
        <div class="inlineRow">{{ sumData.last90DayImpressions }}</div>
        <div class="middleText inlineRow">{{ sumData.last30DayImpressions }}</div>
        <div class="inlineRow">{{ sumData.last7DayImpressions }}</div>
      </div>
      <div class="sum-item">
        <div class="inlineRow">{{ sumData.last90DayClicks }}</div>
        <div class="middleText inlineRow">{{ sumData.last30DayClicks }}</div>
        <div class="inlineRow">{{ sumData.last7DayClicks }}</div>
      </div>
      <div class="sum-item">
        <div class="inlineRow">{{ sumData.last90DayOrders }}</div>
        <div class="middleText inlineRow">{{ sumData.last30DayOrders }}</div>
        <div class="inlineRow">{{ sumData.last7DayOrders }}</div>
      </div>
      <div class="sum-item" style="width: 75px">
        <div class="inlineRow">{{ sumData.last90DayTotal7DayAdSkuCount }}</div>
        <div class="middleText inlineRow">{{ sumData.last30DayTotal7DayAdSkuCount }}</div>
        <div class="inlineRow">{{ sumData.last7DayTotal7DayAdSkuCount }}</div>
      </div>
      <div class="sum-item" style="width: 75px">
        <div class="inlineRow">{{ sumData.last90DayTotal7DayOtherSkuCount }}</div>
        <div class="middleText inlineRow">{{ sumData.last30DayTotal7DayOtherSkuCount }}</div>
        <div class="inlineRow">{{ sumData.last7DayTotal7DayOtherSkuCount }}</div>
      </div>
      <div class="sum-item" style="width: 75px">
        <div class="inlineRow">{{ getPercentageValue(sumData.last90DayClickRate) }}</div>
        <div class="middleText inlineRow">{{ getPercentageValue(sumData.last30DayClickRate) }}</div>
        <div class="inlineRow">{{ getPercentageValue(sumData.last7DayClickRate) }}</div>
      </div>
      <div class="sum-item" style="width: 75px">
        <div class="inlineRow">{{ getPercentageValue(sumData.last90DayConversionRate) }}</div>
        <div class="middleText inlineRow">{{ getPercentageValue(sumData.last30DayConversionRate) }}</div>
        <div class="inlineRow">{{ getPercentageValue(sumData.last7DayConversionRate) }}</div>
      </div>
      <div class="sum-item" style="width: 65px">
        <div class="inlineRow">{{ getFixed2Value(sumData.last90DayROAS) }}</div>
        <div class="middleText inlineRow">{{ getFixed2Value(sumData.last30DayROAS) }}</div>
        <div class="inlineRow">{{ getFixed2Value(sumData.last7DayROAS) }}</div>
      </div>
      <div class="sum-item">
        <div class="inlineRow">{{ getFixed2Value(sumData.last90DayCPC) }}</div>
        <div class="middleText inlineRow">{{ getFixed2Value(sumData.last30DayCPC) }}</div>
        <div class="inlineRow">{{ getFixed2Value(sumData.last7DayCPC) }}</div>
      </div>
      <div class="sum-item">
        <div class="inlineRow">{{ getFixed2Value(sumData.last90DaySpend) }}</div>
        <div class="middleText inlineRow">{{ getFixed2Value(sumData.last30DaySpend) }}</div>
        <div class="inlineRow">{{ getFixed2Value(sumData.last7DaySpend) }}</div>
      </div>
      <div class="sum-item">
        <div class="inlineRow">{{ getFixed2Value(sumData.last90DaySales) }}</div>
        <div class="middleText inlineRow">{{ getFixed2Value(sumData.last30DaySales) }}</div>
        <div class="inlineRow">{{ getFixed2Value(sumData.last7DaySales) }}</div>
      </div>
    </div>

    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { products, activeProducts, colors, models } from "../../utils/constant.js";
import Utils from "../../utils/utils.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 54 - 170 - 68 - 60,
      total: 0,
      pageCount: 1,
      totalPage: 1,
      dataList: [],
      multipleSelection: [],
      asin: this.$route.query.asin,
      entity: this.$route.query.entity,
      productTargetingId: this.$route.query.productTargetingId,
      sku: "",
      productType: "",
      color: "",
      model: "",
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      date: "",
      noTenInfo: {
        weight90Day: 0,
        impressions90Day: 0,
        clicks90Day: 0,
        orders90Day: 0,
        clickRate90Day: 0,
        orderRate90Day: 0,
        spend90Day: 0,
        sales90Day: 0,
        roas90Day: 0,
        roai90Day: 0,

        impressions90Day: 0,
        clicks90Day: 0,
        orders90Day: 0,
        clickRate90Day: 0,
        orderRate90Day: 0,
        spend90Day: 0,
        sales90Day: 0,
        roas90Day: 0,
        roai90Day: 0,
      },
      sumData: {},
      params: {
        pageSize: 100,
        sku: "",
        date: "",
        asin: this.$route.query.asin,
        Entity: "关键词",
        beginIndex: 0,
        productType: this.$route.query.productType > 0 ? ~~this.$route.query.productType : "",
        productColor: "",
        model: "",
        keyword: this.$route.query.searchKeyword,
        delivery: this.$route.query.delivery,
        isDelivery: this.$route.query.isDelivery == 1 ? "1" : "",
        recommandState: "",
        beginTopTenWeight: null,
        endTopTenWeight: null,
        beginOrderRate90Day: null,
        endOrderRate90Day: null,
        beginClickRate90Day: null,
        endClickRate90Day: null,
        beginOrders90Day: null,
        endOrders90Day: null,
        beginRoim90Day: null,
        endRoim90Day: null,
        beginRoas90Day: null,
        endRoas90Day: null,
        beginImpressions90Day: null,
        endImpressions90Day: null,
        beginClicks90Day: null,
        endClicks90Day: null,
        type: "keyword",
        matchType: this.$route.query.matchType,
      },
    };
  },
  watch: {
    "params.productType": {
      handler: function (newValue, oldValue) {
        let parentProduct = this.productList.find(pd => pd.productType == newValue);
        let checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors);
        let checkModels = JSON.parse(parentProduct.checkModels);

        this.colorList = [];
        this.modelList = [...checkModels];

        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
      },
    },
    model: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let model = newValue.replace(blankReg, "");
        this.params.model = model;
      },
    },
  },
  mounted() {
    // this.screenHeight = document.body.clientHeight - 55 - this.$refs.header.clientHeight - this.$refs.pageNav.$el.clientHeight
    // console.log(this.screenHeight, document.body.clientHeight, 55, this.$refs.header.clientHeight, this.$refs.pageNav.$el.clientHeight);
    this.initDefaultDate();
    this.getAdvertData();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 170 - 68 - 60;
    },
    deliveryKeywordClick(keyword) {
      this.params.delivery = keyword;
      this.getAdvertData();
    },
    searchKeywordClick(keyword) {
      this.params.keyword = keyword;
      this.getAdvertData();
    },
    copyKeyword() {
      let txt = "";
      this.dataList.forEach(item => (txt += item.keyword + " "));

      const textarea = document.createElement("textarea");
      textarea.value = txt;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
    batchAddKeyword() {
      this.$confirm("是否确认批量添加到投放?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.multipleSelection.forEach(row => {
            this.submitKeywords({
              asin: row.asin,
              keyword: row.keyword,
              dateStamp: row.dateStamp,
              recommandBid: row.keywordAllPerformance.last90DayCPC.toFixed(2),
              id: row._id,
            });
            // console.log(row.keyword);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    initDefaultDate() {
      console.log("initDefaultDate");
      if (this.date) {
        return;
      }

      let hours = new Date().getHours();
      let offset = 0;
      let usaFirstHour = 16;
      Utils.isDaylightSavingTime() && (usaFirstHour = 15);
      hours < usaFirstHour && (offset = 1);
      this.date = new Date(new Date().getTime() - offset * 24 * 60 * 60 * 1000).format("yyyy-MM-dd");
      this.params.date = this.date;
    },
    autoAdjustAd() {
      requestModules.autoCreateKeywordAdByWeight({ date: this.date }).then(res => {
        this.$confirm("生成完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        });
      });
    },
    submitKeywords(params) {
      requestModules
        .addManualKeywordAdvert({
          asin: params.asin,
          keywords: JSON.stringify([params.keyword]),
          recommandBid: params.recommandBid,
        })
        .then(res => {
          console.log(res);
          // requestModules
          //   .updateKWWeight({
          //     id: params.id,
          //     isDelivery: 1,
          //     deliveryState: "已投放",
          //   })
          //   .then(res => {
          //     console.log(res);
          //     this.getAdvertData();
          //   });
        })
        .catch(res => {
          this.$message({
            type: "error",
            message: res.message,
          });
        });
    },
    addManualProductAdvert(params) {
      requestModules
        .addManualProductAdvert({
          asin: params.asin,
          expandedAsin: params.expandedAsin,
          recommandBid: params.recommandBid,
        })
        .then(res => {
          console.log(res);
        })
        .catch(res => {
          this.$message({
            type: "error",
            message: res.message,
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // onStateChange(row) {
    //   let params = {
    //     id: row._id,
    //     State: row.deliveryState == "已投放" ? "已启用" : "已停用"
    //   }

    //   console.log(params);

    //   requestModules.updateProductAdvert(params).then(res => {
    //     this.$message({
    //       type: 'success',
    //       message: '修改成功!'
    //     });

    //     requestModules.updateKWWeight({
    //       id: params.id,
    //       isDelivery: row.deliveryState == "已投放" ? 1 : 0,
    //       deliveryState: row.deliveryState
    //     }).then(res => {
    //       console.log(res);
    //       this.getAdvertData()
    //     })
    //   });
    // },
    getAdvertData() {
      requestModules.fetchKeywordStatistics(this.params).then(res => {
        this.dataList = res.ldata;
        this.total = res.total;

        this.initSumData();
      });
    },
    initNoTenInfo() {
      let tempList = this.dataList.filter(item => item.impressions >= 10 && item.total7DayAdSkuAmount90Day > 0);
      let topNum = 5;

      this.initTopTenByType(tempList, "clicks90Day");
      this.initTopTenByType(tempList, "impressions90Day");
      this.initTopTenByType(tempList, "orders90Day");
      this.initTopTenByType(tempList, "clickRate90Day");
      this.initTopTenByType(tempList, "orderRate90Day");
      this.initTopTenByType(tempList, "spend90Day");
      this.initTopTenByType(tempList, "sales90Day");
      this.initTopTenByType(tempList, "roas90Day");
      this.initTopTenByType(tempList, "roim90Day");
      this.initTopTenByType(tempList, "weight90Day");

      this.initTopTenByType(tempList, "clicks90Day");
      this.initTopTenByType(tempList, "impressions90Day");
      this.initTopTenByType(tempList, "orders90Day");
      this.initTopTenByType(tempList, "clickRate90Day");
      this.initTopTenByType(tempList, "orderRate90Day");
      this.initTopTenByType(tempList, "spend90Day");
      this.initTopTenByType(tempList, "sales90Day");
      this.initTopTenByType(tempList, "roas90Day");
      this.initTopTenByType(tempList, "roim90Day");
      this.initTopTenByType(tempList, "total7DayAdSkuCount");
      this.initTopTenByType(tempList, "total7DayAdSkuCount90Day");
      this.initTopTenByType(tempList, "total7DayOtherSkuCount");
      this.initTopTenByType(tempList, "total7DayOtherSkuCount90Day");

      this.initTopTenWeight();
    },
    initTopTenWeight() {
      this.dataList.forEach(item => {
        item.topTenWeight = 0;

        for (var key in item) {
          if (key.endsWith("TopTenState") && item[key]) {
            item.topTenWeight++;
          }
        }
      });
    },
    initTopTenByType(dataList, type) {
      if (dataList.length == 0) {
        return;
      }

      let topNum = dataList.length > 5 ? 5 : dataList.length - 1;
      dataList.sort((a, b) => b[type] - a[type]);
      this.noTenInfo[type] = dataList[topNum][type];
      dataList.forEach(item => {
        item[type + "TopTenState"] = item[type] > this.noTenInfo[type];
      });
    },
    getTopTenStyleClass(type, row) {
      if (row.impressions < 10 || row.total7DayAdSkuAmount90Day == 0) {
        return "";
      }
      return row[type] > this.noTenInfo[type] ? "redText" : "";
    },
    getFixed2Value(value) {
      if (!value) {
        return "0.00";
      }
      return value.toFixed ? value.toFixed(2) : "0.00";
    },
    getPercentageValue(value) {
      if (!value) {
        return "0.00";
      }
      return (parseInt(value * 10000) / 100).toFixed(2) + "%";
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getAdvertData();
    },
    keywordAnalysis(row) {
      // let adGroupName = row["Ad Group Name (Informational only)"];

      window.open("/client/searchKeywordMgmt/keywordAnalysis?keyword=" + row.keyword + "&asin=" + row.asin + "&date=" + row.date + "&productType=" + row.productType);
    },
    addDeliveryKeyword(row) {
      this.$confirm("是否确认添加到投放?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitKeywords({
            asin: row.asin,
            keyword: row.keyword,
            dateStamp: row.dateStamp,
            recommandBid: row.keywordAllPerformance.last90DayCPC.toFixed(2),
            id: row._id,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    addDeliveryProduct(row) {
      this.$confirm("是否确认添加到投放?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.addManualProductAdvert({
            asin: row.asin,
            expandedAsin: row.keyword,
            dateStamp: row.dateStamp,
            recommandBid: row.keywordAllPerformance.last90DayCPC.toFixed(2),
            id: row._id,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    initSumData() {
      let sumData = {
        last7DayImpressions: 0,
        last7DayClicks: 0,
        last7DayOrders: 0,
        last7DaySales: 0,
        last7DaySpend: 0,
        last7DayTotal7DayAdSkuCount: 0,
        last7DayTotal7DayOtherSkuCount: 0,
        last7DayUnits: 0,

        last30DayClicks: 0,
        last30DayImpressions: 0,
        last30DayOrders: 0,
        last30DaySales: 0,
        last30DaySpend: 0,
        last30DayTotal7DayAdSkuCount: 0,
        last30DayTotal7DayOtherSkuCount: 0,
        last30DayUnits: 0,

        last90DayClicks: 0,
        last90DayImpressions: 0,
        last90DayOrders: 0,
        last90DaySales: 0,
        last90DaySpend: 0,
        last90DayTotal7DayAdSkuCount: 0,
        last90DayTotal7DayOtherSkuCount: 0,
        last90DayUnits: 0,
      };
      let days = [7, 30, 90];

      days.forEach(day => {
        this.dataList.forEach(data => {
          sumData["last" + day + "DayImpressions"] += data.keywordAllPerformance["last" + day + "DayImpressions"];
          sumData["last" + day + "DayClicks"] += data.keywordAllPerformance["last" + day + "DayClicks"];
          sumData["last" + day + "DayOrders"] += data.keywordAllPerformance["last" + day + "DayOrders"];
          sumData["last" + day + "DaySales"] += data.keywordAllPerformance["last" + day + "DaySales"];
          sumData["last" + day + "DaySpend"] += data.keywordAllPerformance["last" + day + "DaySpend"];
          sumData["last" + day + "DayTotal7DayAdSkuCount"] += data.keywordAllPerformance["last" + day + "DayTotal7DayAdSkuCount"];
          sumData["last" + day + "DayTotal7DayOtherSkuCount"] += data.keywordAllPerformance["last" + day + "DayTotal7DayOtherSkuCount"];
          sumData["last" + day + "DayUnits"] += data.keywordAllPerformance["last" + day + "DayUnits"];
        });
        sumData["last" + day + "DayClickRate"] = sumData["last" + day + "DayClicks"] / sumData["last" + day + "DayImpressions"];
        sumData["last" + day + "DayConversionRate"] = sumData["last" + day + "DayOrders"] / sumData["last" + day + "DayClicks"];
        sumData["last" + day + "DayCPC"] = sumData["last" + day + "DaySpend"] / sumData["last" + day + "DayClicks"];
        sumData["last" + day + "DayACOS"] = sumData["last" + day + "DaySpend"] / sumData["last" + day + "DaySales"];
        sumData["last" + day + "DayROAS"] = sumData["last" + day + "DaySales"] / sumData["last" + day + "DaySpend"];
      });
      console.log(sumData);

      this.sumData = { ...sumData };
      return sumData;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      let impressions = 0;
      let clicks = 0;
      let orders = 0;
      let spend = 0;
      let sales = 0;

      let impressions90Day = 0;
      let clicks90Day = 0;
      let orders90Day = 0;
      let spend90Day = 0;
      let sales90Day = 0;
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
        column.property == "impressions" && (impressions = sums[index]);
        column.property == "clicks" && (clicks = sums[index]);
        column.property == "orders" && (orders = sums[index]);
        column.property == "spend" && (spend = sums[index]);
        column.property == "sales" && (sales = sums[index]);

        column.property == "impressions90Day" && (impressions90Day = sums[index]);
        column.property == "clicks90Day" && (clicks90Day = sums[index]);
        column.property == "orders90Day" && (orders90Day = sums[index]);
        column.property == "spend90Day" && (spend90Day = sums[index]);
        column.property == "sales90Day" && (sales90Day = sums[index]);
      });

      columns.forEach((column, index) => {
        column.property == "cpc" && (sums[index] = (spend / clicks).toFixed(2));
        column.property == "roas" && (sums[index] = (sales / spend).toFixed(2));
        column.property == "roim" && (sums[index] = (sales / impressions).toFixed(2));
        column.property == "clickRate" && (sums[index] = (clicks / impressions).toFixed(2));
        column.property == "orderRate" && (sums[index] = (orders / clicks).toFixed(2));

        column.property == "cpc90Day" && (sums[index] = (spend90Day / clicks90Day).toFixed(2));
        column.property == "roas90Day" && (sums[index] = (sales90Day / spend90Day).toFixed(2));
        column.property == "roim90Day" && (sums[index] = (sales90Day / impressions90Day).toFixed(2));
        column.property == "clickRate90Day" && (sums[index] = (clicks90Day / impressions90Day).toFixed(2));
        column.property == "orderRate90Day" && (sums[index] = (orders90Day / clicks90Day).toFixed(2));
      });
      columns.forEach((column, index) => {
        column.property == "spend" && sums[index] && (sums[index] = sums[index].toFixed(2));
        column.property == "sales" && sums[index] && (sums[index] = sums[index].toFixed(2));
        let name = column.property;
        column.property == "spend90Day" && sums[index] && (sums[index] = sums[index].toFixed(2));
        column.property == "sales90Day" && sums[index] && (sums[index] = sums[index].toFixed(2));
        // column.property == "roim" && sums[index] && (sums[index] = sums[index].toFixed(2))
      });
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      return sums;
    },
    getConversionRateStyleClass(row, key) {
      if (!row || !row.keywordAllPerformance) {
        return "";
      }
      let conversionRate = row.keywordAllPerformance[key];
      let styleClass = "";
      conversionRate >= 0.15 && (styleClass = "greenBg");
      conversionRate < 0.1 && (styleClass = "redBg");
      return styleClass;
    },
    getROASStyleClass(row, key) {
      if (!row || !row.keywordAllPerformance) {
        return "";
      }
      let roas = row.keywordAllPerformance[key];
      let styleClass = "";
      roas >= 3 && (styleClass = "greenBg");
      roas < 1 && (styleClass = "redBg");
      return styleClass;
    },
    getOrderStyleClass(row, key) {
      if (!row || !row.keywordAllPerformance) {
        return "";
      }
      let roas = row.keywordAllPerformance[key];
      let styleClass = "";
      roas >= 2 && (styleClass = "greenBg");
      // roas < 1 && (styleClass = "redBg");
      return styleClass;
    },
    createData() {
      requestModules.runProductKeywordAnalyzeStatistics({}).then(res => {
        this.$confirm("生成数据完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {
          this.getAdvertData();
        });
      });
    },
    runKeywordStatistics() {
      requestModules.runKeywordStatistics({}).then(res => {
        this.$confirm("生成完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {});
      });
    },
  },
};
</script>

<style lang="scss">
#SearchKeywordMgmt {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }

  .sum-box {
    margin-left: 1155px;
    border: 1px solid #ebeef5;
    padding: 5px 0px;

    .sum-item {
      display: inline-block;
      width: 55px;
      text-align: right;
      font-size: 12px;
      border-right: 1px solid #ebeef5;
      background-color: #fafafa;
      padding-left: 2px;
      padding-right: 2px;
      line-height: 14px;

      .middleText {
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        height: 16px;
        line-height: 16px;
      }

      .inlineRow:hover {
        background-color: yellow;
      }
    }
  }

  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }

    .middleText {
      border-top: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      height: 16px;
      line-height: 16px;
    }

    .inlineRow:hover {
      background-color: yellow;
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
